// Extracted from AnnouncementFormPage.tsx: a component file may only export
// components (react-refresh/only-export-components), and these two pure
// converters need a direct unit test (this page has no vitest component-
// render harness: see the file-top TODO in AnnouncementFormPage.tsx).

// Convert datetime-local string to ISO string
export function toISOString(datetimeLocal: string): string {
  if (!datetimeLocal) return datetimeLocal
  return new Date(datetimeLocal).toISOString()
}

// Convert ISO string to datetime-local string.
//
// DAT-1: this reads the browser's own local date/time fields, never a raw
// `iso.slice(0, 16)`: published_at/expires_at are genuine UTC instants
// with a meaningful time of day (not one of the date-only fields CLAUDE.md
// tolerates a UTC slice for), so slicing showed the raw UTC wall-clock time
// (and sometimes the wrong calendar day) as if it were local. Reading via
// `new Date(iso)` + local getters round-trips correctly with toISOString()
// above, which parses a naive datetime-local value as browser-local time.
export function toDatetimeLocal(iso: string): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  const hh = String(d.getHours()).padStart(2, '0')
  const min = String(d.getMinutes()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}T${hh}:${min}`
}
